import React from "react";

const severityStyles = {
  critical: "border-red-500 bg-red-50 text-red-800",
  warning: "border-orange-400 bg-orange-50 text-orange-800",
  info: "border-gray-300 bg-gray-50 text-gray-700",
};

const severityIcons = {
  critical: "🔴",
  warning: "⚠️",
  info: "ℹ️",
};

/**
 * Liste d'alertes structurées
 * Null-safe, affiche vide si pas d'alertes
 */
export default function AlertList({ alerts = [] }) {
  if (!alerts || alerts.length === 0) return null;

  return (
    <div className="space-y-2">
      {alerts.map((alert, idx) => (
        <div
          key={`${alert.code}-${idx}`}
          className={`border-l-4 rounded-lg p-3 ${severityStyles[alert.severity] || severityStyles.info}`}
        >
          <div className="flex items-start gap-2">
            <span className="text-xl">{severityIcons[alert.severity] || "ℹ️"}</span>
            <div className="flex-1">
              <div className="font-semibold">{alert.title}</div>
              <div className="text-sm mt-1">{alert.message}</div>
              {alert.recommended_action && (
                <div className="text-xs mt-2 opacity-80">
                  Action : {alert.recommended_action}
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
